<template>
    <div class="lawsuit_2" v-loading="loading">
        <div class="form_box">
            <div class="form_title">
                <div class="titles">原告</div>
                <div class="btns_box">
                    <div class="btns" @click="handle_form(1)">
                        <img src="../../../assets/img/index/legal/add_img2.png" alt="">新增原告
                    </div>
                </div>
            </div>
            <div class="info_box">
                <div class="item" v-for="(item,index) in info1_list" :key="index">
                    <div class="item_index">
                        <div class="indexs">{{ index+1 }}</div>
                    </div>
                    <div class="users_flex">
                        <div class="name_textbtns">
                            <div class="names">
                                {{ item.name }}
                            </div>
                            <div class="textbtns">
                                <el-button type="text" @click="handle_bj(item,index,'info1_list',1)">编辑</el-button>
                                <el-button type="text" @click="handle_clear(index,'info1_list')">删除</el-button>

                            </div>
                        </div>
                        <div class="user_info" v-if="item.yuangao==1">
                            <div class="text1">性别：{{ item.sex==1?'男':(item.sex==2?'女':'') }}</div>
                            <div class="text1">民族：{{ item.native }}</div>
                            <div class="text1">居住地址：{{ item.address1 }}</div>
                        </div>
                        <div class="user_info" v-if="item.yuangao!=1">
                          
                            <div class="text1">机构所在地址：{{ item.address }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form_box">
            <div class="form_title">
                <div class="titles">被告</div>
                <div class="btns_box">
                    <div class="btns" @click="handle_form(2)">
                        <img src="../../../assets/img/index/legal/add_img2.png" alt="">新增被告
                    </div>
                </div>
            </div>
            <div class="info_box">
                <div class="item" v-for="(item,index) in info2_list" :key="index">
                    <div class="item_index">
                        <div class="indexs">{{ index+1 }}</div>
                    </div>
                    <div class="users_flex">
                        <div class="name_textbtns">
                            <div class="names">
                                {{ item.name }}
                            </div>
                            <div class="textbtns">
                                <el-button type="text" @click="handle_bj(item,index,'info2_list',2)">编辑</el-button>
                                <el-button type="text" @click="handle_clear(index,'info2_list')">删除</el-button>
                            </div>
                        </div>
                        <div class="user_info" v-if="item.yuangao==1">
                            <!-- <div class="text1">性别：{{ item.sex==1?'男':'女' }}</div> -->
                            <div class="text1">性别：{{ item.sex==1?'男':( item.sex==2?'女':'') }}</div>
                            <div class="text1">民族：{{ item.native }}</div>
                            <div class="text1">居住地址：{{ item.address1 }}</div>
                        </div>
                        <div class="user_info" v-if="item.yuangao!=1">
                          
                            <div class="text1">机构所在地址：{{ item.address }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form_box">
            <div class="form_title">
                <div class="titles">第三人</div>
                <div class="btns_box">
                    <div class="btns" @click="handle_form(3)">
                        <img src="../../../assets/img/index/legal/add_img2.png" alt="">新增第三人
                    </div>
                </div>
            </div>
            <div class="info_box">
                <div class="item" v-for="(item,index) in info3_list" :key="index">
                    <div class="item_index">
                        <div class="indexs">{{ index+1 }}</div>
                    </div>
                    <div class="users_flex">
                        <div class="name_textbtns">
                            <div class="names">
                                {{ item.name }}
                            </div>
                            <div class="textbtns">
                                <el-button type="text" @click="handle_bj(item,index,'info3_list',3)">编辑</el-button>
                                <el-button type="text" @click="handle_clear(index,'info3_list')">删除</el-button>
                            </div>
                        </div>
                        <div class="user_info" v-if="item.yuangao==1">
                            <div class="text1">性别：{{ item.sex==1?'男':( item.sex==2?'女':'') }}</div>
                            <div class="text1">民族：{{ item.native }}</div>
                            <div class="text1">居住地址：{{ item.address1 }}</div>
                        </div>
                        <div class="user_info" v-if="item.yuangao!=1">
                          
                            <div class="text1">机构所在地址：{{ item.address }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btns_flex">
            <div class="btns1" @click="handle_end">下一步</div>
            <div class="btns2" @click="handle_shang">上一步</div>
        </div>
        <lawsuit_form ref="lawsuit_form" @handle_add="handle_add"></lawsuit_form>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import lawsuit_form from '@/components/legal_advice/lawsuit/lawsuit_form.vue'



export default {
    components: {
        lawsuit_form
    },
    name: "homes",
    data() {
        return {
            loading: false,
            value: '',
            info1_list:[],
            info2_list:[],
            info3_list:[],
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        if(this.$route.query.order_id){
            this.get_detial()
        }

    },
    methods: {
        get_detial(){
            this.loading=true
            this.$api("appoint2Detail", {
                order_id:this.$route.query.order_id
			}, "get").then((res) => {
                this.loading = false
                console.log('第二部详情',res)
                if (res.code == 1) {
                    this.info1_list=JSON.parse(JSON.stringify(res.data.plaint))
                    this.info2_list=JSON.parse(JSON.stringify(res.data.defendant))
                    this.info3_list=JSON.parse(JSON.stringify(res.data.third))

                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_add(form,bj_form){
            console.log('form',form)
            console.log('bj_form',bj_form)
            if(bj_form.form_text){
                this[bj_form.form_text][bj_form.index]=form  
                let data= this[bj_form.form_text]
                this[bj_form.form_text]=[]
                this[bj_form.form_text]=data
                console.log('this[bj_form.form_text][bj_form.index]',this[bj_form.form_text])
            }else{
                if(form.type==1){
                    this.info1_list.push(form)
                }else if(form.type==2){
                    this.info2_list.push(form)
                }else if(form.type==3){
                    this.info3_list.push(form)
                }
            }
            
        },
        handle_clear(i,form_text){
            this[form_text].splice(i,1)
        },
        handle_end(){
            let obj={}
            if(this.info1_list.length==0){
                alertErr('请新增原告')
                return
            }
            if(this.info2_list.length==0){
                alertErr('请新增被告')
                return
            }
            this.loading=true
            this.$api("appointStep2", {
                order_id:this.$route.query.order_id,
                plaint_json:JSON.stringify(this.info1_list),
                defendant_json:JSON.stringify(this.info2_list),
                third_json:JSON.stringify(this.info3_list),
			}, "post").then((res) => {
                this.loading = false
                console.log('第二部提交',res)
                if (res.code == 1) {
                    this.$emit('handle_end2',obj)
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_shang(){
            this.$emit('handle_shang2')
            
        },
        //1原告 2被告 3第三人
        handle_form(i){
            this.$refs.lawsuit_form.handle_open(i)
        },
        handle_bj(item,index,form_text,i){
            let items=JSON.parse(JSON.stringify(item))
            this.$refs.lawsuit_form.handle_open_bj(items,index,form_text,i)
        },


    },

}
</script>
<style scoped lang="less">
.lawsuit_2 {
    padding: 0 40px;
    padding-top: 80px;

    .form_box {
        padding-bottom: 40px;
        border-bottom: 2px dashed  #B9B9B9;
        margin-bottom: 40px;
        .form_title{
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #E0E3E3;
            .titles{
                padding-bottom: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 18px;
                color: #333333;
                border-bottom: 1px solid #377CFD;
            }
            .btns_box{
                padding-bottom: 16px;
                .btns{
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #377CFD;
                    img{
                        width: 18px;
                        height: 18px;
                        margin-right: 10px;
                    }
                }
            }
          
        }
        .info_box{
            padding-top: 24px;
            .item{
                width: 977px;
                height: 115px;
                background: rgba(55,124,253,0.04);
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E0E3E3;
                padding: 16px;
                display: flex;
                align-items: baseline;
                margin-bottom: 10px;
                .item_index{
                    .indexs{
                        width: 32px;
                        height: 32px;
                        background: #377CFD;
                        line-height: 32px;
                        text-align: center;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        border-radius: 50%;
                    }

                }
                .users_flex{
                    padding-left: 24px;
                    display: flex;
                    flex-wrap: wrap;
                    align-content: space-between;
                    height: 100%;
                    flex:1;
                    .name_textbtns{
                        display: flex;
                        flex:1;
                        align-items: center;
                        justify-content: space-between;
                        .names{
                            // width: 100%;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #333333;
                            
                        }
                        .textbtns{
                            display: flex;
                        }
                    }
                  
                    .user_info{
                        width: 100%;
                        display: flex;
                        align-items: center;
                        .text1{
                            margin-right: 56px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }

                    }
                }
            }
        }
        
    }
    .btns_flex{
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 46px;
        .btns1{
            width: 134px;
            height: 40px;
            background: #377CFD;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #377CFD;
            text-align: center;
            line-height: 40px;
            text-align: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 14px;
            color: #FFFFFF;
            cursor: pointer;

        }
        .btns2{
            width: 134px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #377CFD;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 14px;
            color: #377CFD;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
            margin-left: 16px;
        }
    }
}
</style>